import { PaginationSetting, ResponseObject, ResponseObjectEntity } from '../model/CommonModel';
import { Instance, InstancesPaginated, VelocityVisionResponseObject } from '../model/VelocityVisionModel';
import { Api } from './api';

class VelocityVisionApi extends Api {
	public constructor() {
		super();
	}

	public getInstances = async (paginationSetting: PaginationSetting): Promise<ResponseObjectEntity<InstancesPaginated>> => {
		const url = this.getUrl('VelocityVision/GetVelocityVisionInstances', true);
		const data = {
			paginationSetting,
		};
		return await this.post<ResponseObjectEntity<InstancesPaginated>>(url, data);
	};

	public deleteInstances = async (ids: number[]): Promise<ResponseObject> => {
		const url = this.getUrl('VelocityVision/DeleteVelocityVisionInstance', true);
		const data = {
			ids,
		};
		return await this.post<ResponseObject>(url, data);
	};

	public isInstanceDuplicate = async (instance: Instance): Promise<VelocityVisionResponseObject> => {
		const url = this.getUrl('VelocityVision/IsVelocityVisionInstanceDuplicate', true);
		const data = {
			instance,
		};
		return await this.post<VelocityVisionResponseObject>(url, data);
	};

	public addInstance = async (instance: Instance) => {
		const url = this.getUrl('VelocityVision/AddNewVelocityVisionInstance', true);
		const data = {
			instance,
		};
		return await this.post<ResponseObject>(url, data);
	};

	public updateInstance = async (instance: Instance) => {
		const url = this.getUrl('VelocityVision/UpdateVelocityVisionInstance', true);
		const data = {
			instance,
		};
		return await this.post<ResponseObject>(url, data);
	};
}

const velocityVisionApi = new VelocityVisionApi();

export { velocityVisionApi };
